import {CamToCamParams} from "../application/interfaces";
import {Collection} from "../lib/event-interface";
import {Application} from "../application/application";
import vxServer from "../chatserver/vx-server";
import {ChatServer} from "../chatserver/sx-server";
import {PublisherInterface} from "../publisher/publisher";
import {Status} from "./cam2cam";
import logging from "../utils/log";
import {CamToCamSnapshots} from "./cam2cam-snapshots";

export abstract class CamToCamBase
{
	protected TAG = "[Sxc.Chat.CamToCam]";

	/** If enabled when user switches the camera we restart the cam2cam stream */
	protected SAFE_CAM_SWITCH = true;
	protected aspectRatio: number = 9 / 16;

	public event: Collection;

	// Access to common jquery components
	protected $publisher: JQuery;
	protected $settings: JQuery;

	// Module state
	protected status: Status;
	protected muted: boolean = false;
	protected micAllowed: boolean = true;

	/** If not null this will be used to determine the size of the cam2cam window */
	protected fixedWidth: number;
	protected leftShift: number = 0;

	protected publisher : PublisherInterface;
	protected snapshots : CamToCamSnapshots;

	protected cam : number = 0;
	protected mic : number = 0;

	protected stream : any;

	constructor(protected $root: JQuery,
	                      protected params: CamToCamParams,
	                      protected app: Application)
	{
		this.$publisher = $root.find(".sxccc-publisher-wrapper");
		this.$settings = $root.find(".sxccc-settings");
		this.event = new Collection("cam2cam");

		this.$root.on("click", "[data-c2action]", (e) =>
		{
			let action = $(e.currentTarget).attr("data-c2action");

			switch (action) {
				case "microphone-on":
					this.mute(false);
					break;

				case "microphone-off":
					this.mute(true);
					break;

				case "mini-toggle":
					this.setMini(this.status !== Status.streamingMini);
					break;

				case "settings":
					this.toggleSettings();
					break;

				case "close":
					this.leave();
					break;
			}
		});

		this.mute(this.muted);
		this.setStatus(Status.idle);
		this.snapshots = new CamToCamSnapshots(this.app.chatServer);
	}

	prepareSettings()
	{
		let cams = this.publisher.getCamList();
		let mics = this.publisher.getMicList();

		let $cams = this.$settings.find(".sxcccs-group-cam .sxcccs-group-items").empty();
		let $mics = this.$settings.find(".sxcccs-group-mic .sxcccs-group-items").empty();

		if (!mics.length) {
			mics = ["Microphone"];
		}

		for (let i=0; i<mics.length; i++) {
			if (!mics[i].trim()) {
				mics[i] = "Microphone";
			}
		}

		logging.log(this.TAG, "Detected hardware", cams, mics);

		let fill = ($list, type, items) => {
			for (let i = 0; i<items.length; i++) {
				let label = items[i].replace(/\([0-9abcdef]+:[0-9abcdef]+\)$/i, "");
				$("<div class='sxcccs-group-item' />")
					.text(label)
					.attr("data-type", type)
					.attr("data-id", i.toString())
					.appendTo($list);
			}
		};

		fill($cams, "cam", cams);
		fill($mics, "mic", mics);

		let select = ($from, camID) => {
			$from.find("*").removeClass("sxc-selected");
			$from.find("[data-id=" + camID + "]").addClass("sxc-selected")
		};

		select($cams, this.cam);
		select($mics, this.mic);

		$cams.find(".sxcccs-group-item").click((e) => {
			let idx = parseInt($(e.currentTarget).attr("data-id"), 10);
			select($cams, idx);
			this.cam = idx;
			this.rePublish();
			setTimeout(() => this.toggleSettings(), 200);
		});

		$mics.find(".sxcccs-group-item").click((e) => {
			let idx = parseInt($(e.currentTarget).attr("data-id"), 10);
			select($mics, idx);
			this.mic = idx;
			this.rePublish();
			setTimeout(() => this.toggleSettings(), 200);
		});
	}

	rePublish()
	{
		this.app.chatServer.stopCamToCam();
		this.setStatus(Status.idle);
		this.publisher.unpublish().then(() => {
			setTimeout(() => {this.show(); /*this.publish();*/}, 1)
		});
	}

	public getStatus()
	{
		return this.status;
	}

	public toggleSettings(visible : boolean = null)
	{
		if (this.status !== Status.streaming && this.status !== Status.prepareStream) return;

		if (visible === null) {
			this.toggleSettings(!this.$settings.is(":visible"));
			return;
		}

		if (visible) {
			this.$publisher.addClass("sxccc-settings-visible");
			this.$settings.show();
		} else {
			this.$settings.hide();
			this.$publisher.removeClass("sxccc-settings-visible");
		}
	}

	protected setStatus(status: Status)
	{
		logging.log(this.TAG, "setStatus", Status[status]);

		if (status == Status.idle || status == Status.leaving) {
			this.$root.removeClass("sxc-visible")
		} else {
			this.$root.addClass("sxc-visible")
		}

		if (status === Status.streamingMini) {
			this.toggleSettings(false);
		}

		this.$root.removeClass("sxc-status-idle sxc-status-leaving sxc-status-loading sxc-status-approve sxc-status-noCam sxc-status-camApproved sxc-status-prepareStream sxc-status-streaming sxc-status-streamingMini");
		this.$root.addClass("sxc-status-" + Status[status]);

		this.status = status;
		this.reflow();
		this.event.trigger("stateChange", this.status);
	}

	protected reflow()
	{
		if (this.status == Status.idle
			|| this.status == Status.approve
			|| this.status == Status.noCam
			|| this.status == Status.camApproved
			|| this.status == Status.loading
		)
		{
			this.$publisher.css({top: "", left: "", width: "", height: "",});
			return;
		}

		// Chat position is fixed now.
		let top = 10;
		let right = 10 + this.leftShift;
		let w, h;

		// Chat size is a percentage of the available screen size, except a few cases

		if (this.status === Status.streamingMini)
		{
			// Let css handle this
			this.$publisher.css({top: top, right: right, width: "", height: "",});
		}
		else if (this.fixedWidth)
		{
			w = this.fixedWidth;
			h = w * this.aspectRatio;
			this.$publisher.css({top: top, right: right, width: w, height: h,});
		}
		else
		{
			let size = 0.15;
			let $p = this.$root.parent();
			let pw = $p.innerWidth();
			let ph = $p.innerHeight();

			h = Math.round(Math.min(160, Math.max(200, ph * size)));
			w = Math.round(h / this.aspectRatio);

			this.$publisher.css({top: top, right: right, width: w, height: h,});
		}
	}

	protected mute(muted: boolean)
	{
		if (!this.micAllowed) return;
		this.muted = muted;

		this.$root.find("button[data-c2action=microphone-on]")
			[muted ? "show" : "hide"]();

		this.$root.find("button[data-c2action=microphone-off]")
			[muted ? "hide" : "show"]();

		if (this.publisher) {
			this.publisher.mute(this.micAllowed ? this.muted : true)
		}
	}

	public allowMic(allow: boolean)
	{
		this.micAllowed = allow;
		this.$root[!allow ? "addClass" : "removeClass"]("mic-disabled");
		if (this.publisher) {
			this.publisher.mute(this.micAllowed ? this.muted : true)
		}
	}

	public setMini(mini: boolean)
	{
		if (this.status !== Status.streaming && this.status !== Status.prepareStream && this.status !== Status.streamingMini) return;

		this.setStatus(mini ? Status.streamingMini : Status.streaming)
	}

	public isMini()
	{
		return this.status === Status.streamingMini;
	}

	/**
	 * Sets a fixed with for cam2cam.
	 *
	 * @param w The desired width. If null, width will be calculated based on
	 *          the available screen size
	 */
	public setFixedWidth(w: number)
	{
		this.fixedWidth = w;
		this.reflow();
	}

	public shiftLeft(number: number)
	{
		this.leftShift = number;
		this.reflow();
	}

	public isStreaming()
	{
		return this.status == Status.streamingMini
			|| this.status == Status.streaming
			|| this.status == Status.prepareStream;
	}

	public leave(): Promise<any>
	{
		logging.log(this.TAG, "leave...");

		this.setStatus(Status.leaving);

		if (!this.publisher) {
			this.$root.removeClass("sxc-visible");
			this.setStatus(Status.idle);
			return Promise.resolve();
		}

		this.app.chatServer.stopCamToCam();

		this.snapshots.clear();
		this.snapshots.cancel();

		return this.publisher.destroy()
			.then(() => {
				this.$root.removeClass("sxc-visible");
				this.setStatus(Status.idle);
			});
	}

	public getSize()
	{
		return {w: this.$publisher.width(), h: this.$publisher.height()};
	}

	isSettingsVisible()
	{
		return this.$settings.is(":visible")
	}

	esc()
	{
		this.toggleSettings(false);
	}

	abstract show(): Promise<any>;
	abstract publish();
}
